import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { SvgIcon } from 'Components/Base';
import { Modal, ModalContent, ModalFooter } from 'Components/Modal';
import { getAppUIVariantConfig } from 'Util/uiVariantSet';

const NoCourseModal = ({ isActive, description, onPurchaseClick, onOCDClick, footer }) => {
  const { t } = useTranslation('classroom');
  const { Modal: modalVariant } = getAppUIVariantConfig();

  switch (modalVariant) {
    case 'Rounded':
    default: {
      return (
        <Modal
          contents={
            <ModalContent
              iconName={SvgIcon.ICON_LIST.WARNING}
              title={t('ERROR.ENTER_CLASSROOM.TITLE')}
              description={description}
            />
          }
          footerProps={{ mt: 7 }}
          footer={
            <ModalFooter
              width={1}
              flexDirection={{ _: 'column-reverse', md: 'row' }}
              justifyContent={'center'}
              primaryButtonLabel={
                typeof onPurchaseClick === 'function' && t('ERROR.ENTER_CLASSROOM.PURCHASE_BUTTON')
              }
              onPrimaryButtonClick={onPurchaseClick}
              secondaryButtonLabel={t('ERROR.ENTER_CLASSROOM.OCD_BUTTON')}
              onSecondaryButtonClick={onOCDClick}
            />
          }
          muiProps={{ isActive }}
        />
      );
    }
  }
};

NoCourseModal.propTypes = {
  isActive: PropTypes.bool,
  description: PropTypes.string,
  onPurchaseClick: PropTypes.func,
  onOCDClick: PropTypes.func,
  footer: PropTypes.element,
};

export default NoCourseModal;
